module.exports = __webpack_public_path__ + "img/payx_logo.4a30e39b.png";